<div
  class="lane"
  [class.compact]="compact()"
  [attr.data-grid-col]="gridColKey()"
  [style.height.px]="laneHeightPx()">

  <!-- Sticky corner caps: the lane reads as rounded at whatever is VISIBLE —
       the top cap pins just below the sticky header, the bottom cap to the
       scrollport's bottom edge, each masking the corners with an inverse
       radius. At the lane's real ends they align with the genuine rounded
       corners, so the effect is seamless while scrolling. -->
  <div class="lane-cap top" aria-hidden="true"></div>

  @for (cell of freeCells(); track cell.startTimeUtc) {
    <div
      class="free-cell"
      [class.out-of-lead-time]="cell.outOfLeadTime"
      [style.top.px]="cell.top"
      [style.height.px]="cell.height"
      role="button"
      tabindex="0"
      [attr.aria-disabled]="cell.outOfLeadTime ? 'true' : null"
      [attr.aria-label]="freeCellAriaLabel(cell)"
      (pointerdown)="onFreeCellPointerDown($event, cell)"
      (click)="onFreeCellActivate(cell)"
      (keydown.enter)="onFreeCellActivate(cell)"
      (keydown.space)="onFreeCellActivate(cell); $event.preventDefault()">
    </div>
  }

  @for (seg of segments(); track seg.startTimeUtc) {
    @let height = segHeight(seg);
    @let tier = segmentTier(height);
    @let clickable = isCourseClickable(seg);
    <div
      class="segment-block"
      [ngClass]="[segmentKindClass(seg), 'tier-' + tier]"
      [class.past]="seg.isPast === true"
      [class.course-clickable]="clickable"
      [style.top.px]="segBlockTop(seg)"
      [style.height.px]="segBlockHeight(height)"
      [title]="segmentTitle(seg)"
      [attr.role]="clickable ? 'button' : null"
      [attr.tabindex]="clickable ? 0 : null"
      [attr.aria-label]="clickable ? courseAriaLabel(seg) : null"
      (click)="onCourseSegmentActivate(seg)"
      (keydown.enter)="onCourseSegmentActivate(seg)"
      (keydown.space)="onCourseSegmentActivate(seg); $event.preventDefault()">
      @if (seg.kind !== 'past') {
        <!-- Same wording source as the classic grid (plan §6.4.3) — see
             court-segment-label.util. -->
        <span class="segment-type">{{ segmentText(seg) }}</span>
        <span class="segment-time" [class.compact]="tier === 'xs'">{{ formatRange(seg.startTimeUtc, seg.endTimeUtc) }}</span>
      }
      @if (seg.isOwn) {
        <!-- "Ecke" own-booking corner badge — same indicator as the classic grid. -->
        <span
          class="own-corner-triangle"
          role="img"
          [title]="ownBadgeLabel(seg)"
          [attr.aria-label]="ownBadgeLabel(seg)"></span>
        <span class="own-corner-check" aria-hidden="true">✓</span>
      }
    </div>
  }

  @if (selection(); as sel) {
    <!-- Same interactions as the classic grid: drag the body to move the
         whole slot (also onto another court/day), drag the top/bottom
         handles to shift start or end. The root owns every drag session. -->
    <div
      class="lane-selection"
      [class.dragging]="sel.dragging"
      [class.invalid]="sel.invalid"
      [style.top.px]="selectionTop(sel)"
      [style.height.px]="selectionHeight(sel)"
      (pointerdown)="onSelectionBodyPointerDown($event)">
      <div
        class="lane-resize-handle top"
        title="Beginn ändern"
        (pointerdown)="onResizeHandlePointerDown($event, 'resize-top')">
        <div class="grip"></div>
      </div>
      <span class="lane-selection-label">{{ sel.label }}</span>
      <div
        class="lane-resize-handle bottom"
        title="Ende ändern"
        (pointerdown)="onResizeHandlePointerDown($event, 'resize-bottom')">
        <div class="grip"></div>
      </div>
    </div>
  }

  <div class="lane-cap bottom" aria-hidden="true"></div>
</div>
